import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ViewChild,
  ChangeDetectorRef,
  ViewEncapsulation,
  ElementRef,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { OrderFile, Order } from "src/app/shared/models/order.model";
import { UiService } from "src/app/shared/services/ui.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ChatContact } from "src/app/shared/models/chat.model";
import { SharedService } from "src/app/shared/services/shared.service";
import { AuthService } from "src/app/shared/services/auth.service";
import { BroshService } from "src/app/shared/services/brosh.service";
import { Store } from "@ngrx/store";
import { currentOrder, ui_direction } from "src/app/shared/ngrx/ngrx-selectors";
import { SEND_FILE_CHAT_MSG } from "src/app/shared/ngrx/ngrx-actions";
import { CommonModule } from "@angular/common";
import { PdfViewerComponent } from "../rx-form/pdf-viewer/pdf-viewer.component";
// import { VideoPlayerComponent } from "@mintplayer/ng-video-player";
import { ImageViewComponent } from "src/app/shared/components/image-view/image-view.component";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";

@Component({
  selector: "file-preview",
  templateUrl: "./file-preview.component.html",
  styleUrls: ["./file-preview.component.scss"],
  standalone: true, encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    TranslateModule,
    PdfViewerComponent,
    // VideoPlayerComponent,
    ImageViewComponent,
    NgxExtendedPdfViewerModule,
  ],
})
export class FilePreviewComponent implements OnInit, AfterViewInit, OnDestroy {
  // @ViewChild(VideoPlayerComponent, { static: false })
  // player1: VideoPlayerComponent;

  @ViewChild(ImageViewComponent, { static: false })
  imageView: ImageViewComponent;

  @ViewChild('dialogContainer', { static: false }) dialogContainer: ElementRef;
  private resizeObserver: ResizeObserver;

  @Input() fileList: OrderFile[] = [];
  @Input() currentFile: OrderFile;
  @Input() showSendInChat: boolean = true;
  @Input() showDelete: boolean = true;
  @Output() onClose = new EventEmitter();

  allowDeleteFile: boolean;
  state: string = "default";
  rotatedSw: boolean;
  pdfUrl: string;
  pdfUrlSafe: SafeResourceUrl;
  htmlUrlSafe: SafeResourceUrl;
  vidFullScr: boolean;
  instance: any;
  zoomStep = 1;
  mouseDownSw: boolean;
  prevX: number;
  prevY: number;
  imageIndex: number = 0;

  urlList: string[] = [];

  rotation = 0;

  get imgContainer(): HTMLElement {
    return document.getElementById("imgContainer");
  }

  get currentOrder(): Order {
    return this.store.selectSignal(currentOrder)();
  }

  get allowSendInChat(): boolean {
    return this.showSendInChat;
  }

  constructor(
    private uiService: UiService,
    private readonly store: Store,
    private sanitizer: DomSanitizer,
    private translateService: TranslateService,
    private sharedService: SharedService,
    private authService: AuthService,
    private broshService: BroshService,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.urlList = this.fileList.map((f) => f.url);
    this.imageIndex = this.fileList.indexOf(this.currentFile);

    this.allowDeleteFile =
      this.showDelete &&
      this.authService.currentUser.authDetails.getBooleanValue(
        "ORDERS.ALLOW_DELETE_FILE"
      );

    this.initPreview();

  }

  ngAfterViewInit(): void {
  }

  ngOnDestroy(): void {

  }


  updPdfUrl() {
    this.pdfUrl = this.currentFile.url + "#toolbar=0&navpanes=0";
    this.pdfUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
  }

  updHtmlUrl() {
    this.htmlUrlSafe = this.sanitizer.bypassSecurityTrustResourceUrl(this.currentFile.url);
  }

  closePanel() {
    this.onClose.emit();
  }

  get isRTL(): boolean {
    return this.store.selectSignal(ui_direction)() == "rtl";
  }

  isImg(): boolean {
    return this.uiService.isImage(this.currentFile.url);
  }

  isPdf(): boolean {
    return this.currentFile.fileType == "pdf";
  }

  isHtml(): boolean {
    return this.currentFile.fileType == "html";
  }

  isVideo(): boolean {
    return this.currentFile.isVideo;
  }

  getPdfUrl() {
    let url = this.currentFile.url + "#toolbar=0";
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  get curIdx(): number {
    return this.fileList.indexOf(this.currentFile);
  }

  download() {
    if (this.isPdf) {
      this.forceDownload(
        this.currentFile.url,
        this.currentFile.url.substr(this.currentFile.url.lastIndexOf("/") + 1)
      );
    } else {
      this.openUrl();
    }
  }

  forceDownload(url, fileName) {
    var x = new XMLHttpRequest();
    x.open("GET", url, true);
    x.responseType = "blob";
    x.onload = (e: any) => {
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(x.response);
      link.target = "_blank";
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(e.response);
    };
    x.send();
  }

  openUrl() {
    window.open(this.currentFile.url, "_blank");
  }

  copyToClipboard() {
    if (navigator.clipboard && window.isSecureContext) {
      // Use the modern clipboard API
      navigator.clipboard.writeText(this.currentFile.url).then(() => {
        // Show success feedback (you might want to add a toast notification here)
        console.log('URL copied to clipboard');
      }).catch(err => {
        console.error('Failed to copy URL: ', err);
      });
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = this.currentFile.url;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      try {
        document.execCommand('copy');
        console.log('URL copied to clipboard');
      } catch (err) {
        console.error('Failed to copy URL: ', err);
      }
      document.body.removeChild(textArea);
    }
  }

  hasPrev(): boolean {
    return this.curIdx > 0;
  }

  hasNext(): boolean {
    return this.curIdx < this.fileList.length - 1;
  }

  next() {
    this.imageIndex = this.curIdx + 1;
    this.initPreview();
  }

  prev() {
    this.imageIndex = this.curIdx - 1;
    this.initPreview();
  }

  initPreview() {
    this.currentFile = this.fileList[this.imageIndex];
    this.updPdfUrl();
    this.updHtmlUrl();
    this.setInitialDialogSize();
  }

  private setInitialDialogSize(): void {
    // Set initial dialog size after a short delay to ensure DOM is ready
    setTimeout(() => {
      const dialogElement = document.querySelector('.p-dialog') as HTMLElement;
      if (dialogElement) {
        dialogElement.style.width = '900px';

        // if (this.uiService.isImage(this.currentFile.url)) {
        //   dialogElement.style.width = '500px';
        // } else {
        //   dialogElement.style.width = '900px';
        //   // Don't set fixed height for iframes to allow vertical resizing
        //   // The dialog will size based on content and user can resize
        // }
      }
    }, 100);
  }

  sendInChat(chatContact: ChatContact) {
    this.store.dispatch(
      SEND_FILE_CHAT_MSG({
        orderFile: this.currentFile,
        chatContact: chatContact,
      })
    );
  }

  getChatTitle(chatContact: ChatContact): string {
    if (chatContact.contactId == "CLINIC") {
      return this.translateService.instant(
        "translate.order.sendFileInChatToClinic"
      );
    } else if (chatContact.contactId == "PLANT") {
      return this.translateService.instant(
        "translate.order.sendFileInChatToPlant"
      );
    } else if (chatContact.contactId == "LAB") {
      return this.translateService.instant(
        "translate.order.sendFileInChatToLab"
      );
    }
  }

  delete() {
    let validationStr = this.translateService.instant(
      "translate.validation.deleteFile"
    );

    this.sharedService.emitPopupchReceivedEvent({
      title: "translate.chat.deleteFilePrompt",
      icon: "exclamation-triangle",
      subTitle: validationStr,
      keep: false,
      approve: () => {
        this.broshService
          .deleteFile(this.currentOrder, this.currentFile)
          .subscribe((data) => {
            this.fileList.splice(this.fileList.indexOf(this.currentFile), 1);
            this.closePanel();
          });
      },
    });
  }

  rotate() {
    this.imageView?.rotate();
  }

  zoomIn() {
    this.imageView?.zoomIn();
  }

  zoomOut() {
    this.imageView?.zoomOut();
  }
}
